module.exports = __webpack_public_path__ + "img/darkheader.3b05e81a.png";